export const EditorPositionNavbar = {
  Expand: {
    title: (el) => el.call('polyglot', 'editor.position.expand'),
    icon: (el) => 'arrowCompact' + (el.getUserSettings('editorPanelsAtRight') ? 'Left' : 'Right'),
    margin: '- - - auto',
    hide: (el) => {
      const EditorPanels = el.getEditorPanels()
      return EditorPanels?.isExpanded
    },
    onClick: (ev, el) => {
      const EditorPanels = el.getEditorPanels()
      EditorPanels?.update({
        isExpanded: true
      })
    }
  },
  Minimize: {
    title: (el) => el.call('polyglot', 'editor.position.minimize'),
    icon: (el) => 'arrowCompact' + (el.getUserSettings('editorPanelsAtRight') ? 'Right' : 'Left'),
    margin: '- - - auto',
    hide: (el) => {
      const EditorPanels = el.getEditorPanels()
      return !EditorPanels?.isExpanded
    },
    onClick: (ev, el) => {
      const EditorPanels = el.getEditorPanels()
      EditorPanels?.update({
        isExpanded: false
      })
    }
  },
  Left: {
    title: (el) => el.call('polyglot', 'editor.position.alignLeft'),
    icon: 'boxFilledLeft',
    hide: (el) => !el.getUserSettings('editorPanelsAtRight'),
    onClick: (ev, el) => {
      const EditorPanels = el.getEditorPanels()
      el.call('setUserSettings', 'editorPanelsAtRight', false)
      EditorPanels?.update()
    }
  },
  Right: {
    title: (el) => el.call('polyglot', 'editor.position.alignRight'),
    icon: 'boxFilledRight',
    hide: (el) => el.getUserSettings('editorPanelsAtRight'),
    onClick: (ev, el) => {
      const EditorPanels = el.getEditorPanels()
      el.call('setUserSettings', 'editorPanelsAtRight', true)
      EditorPanels?.update()
    }
  },
  extends: 'NavbarButtonSet'
}
